module.exports = __webpack_public_path__ + "site/img/0.26d93f72.jpg";